import React from 'react';
import EmptyNumbersScreen from './EmptyNumbersScreen';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/layouts/tabsContainerStyle';
import { makeStyles } from '@material-ui/styles';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';

// @ts-ignore
const useStyles = makeStyles(styles);

const EmptyTab = ({
	onClick,
	onClickCancel,
	loading,
	cancelScreen,
}: {
	onClick: () => void;
	onClickCancel: () => void;
	loading: boolean;
	cancelScreen: boolean;
}) => {
	const classes = useStyles();

	return (
		<>
			<EmptyNumbersScreen cancelScreen={cancelScreen}>
				<>
					<ConditionalRender
						show={cancelScreen}
						onTrue={() => (
							<Button color="tertiary-light" onClick={onClickCancel}>
								{translate('cancel')}
							</Button>
						)}
					/>
					<Button color="primary-light" onClick={onClick}>
						{translate(cancelScreen ? 'remove' : 'purchase.bulk.devices.order.create')}
					</Button>
				</>
			</EmptyNumbersScreen>
			<ConditionalRender
				show={!!loading}
				onTrue={() => (
					<div className={classes.loadingWrapper}>
						<CustomCircularProgress text={translate('loading.it.can.take.a.while')} loading transparent />
					</div>
				)}
			/>
		</>
	);
};

export default EmptyTab;
